export const COURSE_VERTICAL_CARD_WIDTH = 200
export const COURSE_VERTICAL_CARD_SLIDER_MARGIN = 24
